import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Alert, Box, Button, CircularProgress, Paper, Typography } from '@mui/material';
import MainLayout from '../layouts/MainLayout';
import { useAuth } from '../context/AuthContext.jsx';
import { isFullAdminUser } from '../utils/adminAccess.js';

const POS_PORTAL_URL = (import.meta.env.VITE_POS_PORTAL_URL || 'https://pos.suuq-s.com').replace(/\/+$/, '');

function NotAnAdmin({ email, onLogout }) {
  return (
    <Box minHeight="100dvh" display="flex" alignItems="center" justifyContent="center" px={2}>
      <Paper variant="outlined" sx={{ p: 4, maxWidth: 440 }}>
        <Typography variant="h6" gutterBottom>
          This is the Suuq platform admin
        </Typography>
        <Alert severity="warning" sx={{ mb: 2 }}>
          {email || 'This account'} is not a platform admin.
        </Alert>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Branch owners, staff and suppliers manage their business on pos.suuq-s.com.
        </Typography>
        <Box display="flex" gap={1}>
          <Button variant="contained" href={POS_PORTAL_URL}>
            Go to Suuq POS
          </Button>
          <Button onClick={onLogout}>Sign out</Button>
        </Box>
      </Paper>
    </Box>
  );
}

export default function ProtectedRoute() {
  const { isAuthenticated, loading, user, logout } = useAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (!isFullAdminUser(user)) {
    return <NotAnAdmin email={user?.email} onLogout={logout} />;
  }

  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
}
